import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61b383e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "user-badge dropdown"
}
const _hoisted_2 = {
  class: "initials",
  href: "#",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = {
  class: "dropdown-menu dropdown-menu-dark dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "dropdown-item",
    type: "button",
    href: "/edit"
  }, "Edit projects")
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  type: "button",
  href: "/dashboard"
}, "Dashboard", -1))
const _hoisted_7 = [
  _hoisted_6
]

import { useUserStore } from "@/store/user-store";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBadge',
  setup(__props) {

const userStore = useUserStore();

const initials = computed(() => {
	let names = userStore.state.user?.name.split(" ");
	var lastnameInitial = names.length > 1 && names[1].length > 0 ? names[1][0] : "";
	var firstnameInitial = names.length > 0 && names[0].length > 0 ? names[0][0] : ""
	return firstnameInitial + lastnameInitial;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(userStore).isLoggedIn())
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(userStore).login()))
        }, "Login"))
      : _createCommentVNode("", true),
    (_unref(userStore).isLoggedIn())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", _hoisted_2, _toDisplayString(_unref(initials)), 1),
          _createElementVNode("ul", _hoisted_3, [
            _hoisted_4,
            (_unref(userStore).state.user.admin == true)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(userStore).logout()))
              }, "Logout")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})